// UserMessage.js
import React from 'react';
import { motion } from 'framer-motion';
import Time from './Time';

const TextMessage = ({ text, time, senderType, selectedColor, textColor }) => {
  const animationProps = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
  };

  return (
    <div
      className={`flex mb-2 ${senderType === 'user' ? 'justify-end' : 'justify-start'}`}
    >
      <motion.div
        className="max-w-[75%] md:max-w-[50%] lg:max-w-[70%]"
        {...animationProps}
      >
        <div
          className={`text-sm p-3 break-words rounded-tl-2xl rounded-tr-2xl whitespace-pre-line ${
            senderType === 'user'
              ? textColor.token + ' rounded-bl-2xl'
              : 'bg-callbell-light-gray text-black rounded-br-2xl'
          }`}
          style={{ backgroundColor: senderType === 'user' ? selectedColor : '' }}
        >
          {text}
        </div>
        <Time time={time} senderType={senderType} />
      </motion.div>
    </div>
  );
};

export default TextMessage;
